---
id: apps-app-react-src-rezi-app-dashboard-components-jobs-doc
title: Dashboard Jobs Module
owner: Luc Lemerez
status: Deleted
lastReviewed: 2026-05-21
visibility: confidential
tags:
  - app-react
  - dashboard
  - jobs
  - recommendations
---

## Product Overview

Recommended jobs carousel shown on the user dashboard. It highlights job
matches based on the user's preferences and provides a way to set preferences
or refresh results from the same surface.

### Primary Workflow
Users see recommended jobs when preferences are available, scroll through a
horizontal list, and open or save jobs directly from the card UI. When no
preferences exist, the module prompts for role and location before fetching
recommendations.

### Business Logic
Recommendations are driven by stored role and location preferences. The module
keeps the job search store in sync with those preferences, and disables
carousel controls when there are no resumes, no preferences, or no job results.

### Outcomes
The module surfaces personalized job matches inside the dashboard to drive
engagement with job search and job saving flows without leaving the home view.

### Out of Scope
Full job search results, filters, and detailed job exploration live outside
this dashboard component.

## Technical Overview

The module entry point in
`apps/app-react/src/rezi-app/dashboard/components/jobs/jobs.tsx` manages
preference fetching, recommendation fetching, and scroll state, and renders the
carousel or empty states accordingly.

### Entry Points
`apps/app-react/src/rezi-app/dashboard/components/jobs/jobs.tsx` owns the
dashboard carousel, preference form, and recommendation refresh paths. Job card
presentation is handled by
`apps/app-react/src/rezi-app/dashboard/components/jobs/job-card.tsx`, and
loading skeletons live in
`apps/app-react/src/rezi-app/dashboard/components/jobs/ghost-loading.tsx`.

### Key Modules
The jobs module integrates with job search providers from
`src/rezi-app/jobs/components` and uses hooks in
`src/rezi-app/jobs/hooks/use-job-recommendations` for preferences and
recommendation requests. It uses the job search store from
`@rezi/stores/providers/root-store-provider` to persist and manage saved jobs.

### Data and Services
Preference data comes from `useJobPreferences`, updates flow through
`useUpdateJobPreferences`, and recommendations are fetched via
`useJobRecommendations`.

### Integrations and Side Effects
Submitting preferences updates the job search store and triggers a new
recommendations fetch. Scrolling state is tracked to enable or disable carousel
navigation buttons.

### Constraints and Risks
Recommendation availability depends on both stored preferences and the
recommendations service response, so missing or stale preferences result in an
empty state rather than a carousel.

## Changelog

- 2026-05-21: Module deleted. `dashboard/components/jobs/jobs.tsx`, `jobs/hooks/use-job-recommendations.ts`, and the associated `useJobPreferences` / `useUpdateJobPreferences` / `useJobRecommendations` hooks were removed. The dashboard recommendations carousel has been replaced by the unified job board (`src/rezi-app/jobs`).
- 2026-01-27: Expanded product and technical overviews to cover business logic and key code paths.
- 2026-01-26: Marked inactive and confidential (not currently used).
- 2026-01-26: Initial documentation.
